
export class AppHTMLText {

    getItem = new Array();
    constructor() {
    }


}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/appHtmlText.ts